import { render } from "./MainNavigation.vue?vue&type=template&id=6da83566"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
script.render = render

export default script